export default __webpack_public_path__ + "static/media/review.37c5fee4.svg";